import styled from "@emotion/styled";
import { Theme } from "@mindlercare/ui-web";

type LinkButtonProps = {
  underline?: boolean;
  color?: keyof Theme["COLORS"];
};

export const LinkButton = styled.button<LinkButtonProps>`
  display: inline;
  background: none;
  border: none;
  text-decoration: ${(props) => (props.underline ? "underline" : "none")};
  font-size: 14px;
  cursor: pointer;
  color: ${(props) => props.color || "inherit"};
  padding: 0;
`;
